module.exports = __webpack_public_path__ + "static/media/ornament.8b7b2bb1.svg";